import React from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import { H1 } from "theme/components/atoms/Typography/Heading";
import { BodyParagraph } from "theme/components/atoms/Typography/Body";

const PageError = () => (
  <div className="page-content page-content--simple page-content--error">
    <div className="container">
      <H1>
        <FormattedMessage
          id="modules.Error.title"
          defaultMessage="Something went wrong."
        />
      </H1>
      <BodyParagraph>
        <FormattedMessage
          id="modules.Error.body"
          defaultMessage="An error occured while this page was loading. Please try to load the page again and {link} if the error persists."
          values={{
            link: (
              <Link to="/contact">
                <FormattedMessage
                  id="modules.Error.contactLinkLabel"
                  defaultMessage="contact us"
                />
              </Link>
            ),
          }}
        />
      </BodyParagraph>
    </div>
  </div>
);

export default PageError;
